import React, { useState } from "react";
import api from "../lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Sparkles, Loader2 } from "lucide-react";

const STATIC_FAQS = [
  { q: "Do you ship across India?", a: "Yes — we offer free shipping on orders above ₹1,499 across India. Standard delivery is 3–7 business days." },
  { q: "What is your return policy?", a: "Unused products in original packaging can be returned within 30 days for a full refund." },
  { q: "Is COD available?", a: "Yes, Cash on Delivery is available across most PIN codes." },
  { q: "Are your products physiotherapist approved?", a: "Every Welljio product is designed in collaboration with licensed physiotherapists." },
  { q: "Do you offer GST invoices?", a: "Yes — for any order, request a GST invoice at checkout or via support@welljio.com." },
  { q: "How long does memory foam last?", a: "Our high-density memory foam retains shape for 3+ years with regular use." },
];

export default function FAQPage() {
  const [q, setQ] = useState("");
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);

  const ask = async (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    setLoading(true);
    setAnswer("");
    try {
      const { data } = await api.post(`/ai/faq`, { question: q });
      setAnswer(data.answer);
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="faq-page" className="max-w-3xl mx-auto px-6 py-12">
      <p className="text-xs uppercase tracking-widest text-welljio-subtle text-center mb-3">Help center</p>
      <h1 className="font-heading text-5xl sm:text-6xl font-bold tracking-tight text-center">FAQ.</h1>

      <form onSubmit={ask} className="mt-12 bg-white border border-slate-100 rounded-3xl p-6">
        <p className="text-xs uppercase tracking-widest text-welljio-accent mb-3 flex items-center gap-2"><Sparkles className="w-3.5 h-3.5" strokeWidth={1.5}/> Ask the assistant</p>
        <div className="flex gap-2">
          <input
            data-testid="faq-ai-input"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Ask anything about products, shipping, or care..."
            className="flex-1 border border-slate-200 rounded-full px-5 py-3 outline-none focus:border-welljio-accent text-sm"
          />
          <button disabled={loading} data-testid="faq-ai-submit" className="bg-welljio-ink text-white rounded-full px-6 text-sm font-medium hover:bg-slate-800 disabled:opacity-60 flex items-center gap-2">
            {loading ? <Loader2 className="w-4 h-4 animate-spin"/> : "Ask"}
          </button>
        </div>
        {answer && (
          <div data-testid="faq-ai-answer" className="mt-5 p-5 bg-welljio-highlight rounded-2xl text-sm text-welljio-ink leading-relaxed">{answer}</div>
        )}
      </form>

      <h2 className="font-heading text-2xl font-semibold mt-14 mb-4">Common questions</h2>
      <Accordion type="single" collapsible className="space-y-3">
        {STATIC_FAQS.map((f, i) => (
          <AccordionItem key={i} value={`faq-${i}`} className="border border-slate-100 rounded-2xl bg-white px-5">
            <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-heading font-semibold">{f.q}</AccordionTrigger>
            <AccordionContent className="text-welljio-muted">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
